var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "menu" } },
    [
      _vm._l(Object.keys(_vm.menuItems), function (title) {
        return _c(
          "div",
          { key: title, staticClass: "menu-wrapper" },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t(`etc.menu.${title}`))),
            ]),
            _vm._l(_vm.menuItems[title], function (menu, i) {
              return [
                !menu.onlyLogin &&
                (!menu?.openDate || _vm.openMenu(menu?.openDate))
                  ? _c(
                      "button",
                      {
                        key: i,
                        staticClass:
                          "d-flex align-items-center nav-main-link w-100",
                        on: {
                          click: function ($event) {
                            return menu.clickFunc(menu.route)
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "icon",
                          attrs: {
                            src: `${_vm.$s3}/img/${menu.img}?${_vm.$ver}`,
                          },
                        }),
                        _c("span", { staticClass: "ml-2" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t(menu.title)) +
                              "\n          "
                          ),
                          menu.img === "lotto"
                            ? _c("img", {
                                staticClass: "mb-1",
                                attrs: {
                                  src: `${_vm.$s3}/img/common/beta.svg?${_vm.$ver}`,
                                },
                              })
                            : _vm._e(),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]
            }),
          ],
          2
        )
      }),
      _vm.isLogin
        ? [
            _c("div", { staticClass: "split-line" }),
            _c("Attendance", { attrs: { "side-bar": _vm.sideBar } }),
          ]
        : _c("div", { staticStyle: { "padding-bottom": "20px" } }),
      _vm.isMobile
        ? _c("div", {
            staticClass: "gap-fill",
            style: { height: _vm.innerHeight },
          })
        : _vm._e(),
      _c("Modal", {
        ref: "swap-mobile-menu",
        attrs: { id: "swap-mobile-menu" },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }